import { PreloadedQuery } from 'react-relay';
import type { VariablesOf } from 'relay-runtime';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';
import { tqlQueryFromInput } from '@townsquare/tql/query';
import { ComparatorOperator } from '@townsquare/tql/types';

import GoalSettingsViewQuery, {
	GoalSettingsViewQuery as GoalSettingsViewQueryType,
} from '../components/GoalSettings/__generated__/GoalSettingsViewQuery.graphql';

export const goalSettingsPageResource: RouteResource<
	PreloadedQuery<GoalSettingsViewQueryType, Record<string, unknown>>
> = createRelayResource<GoalSettingsViewQueryType>({
	getQuery: (_routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		const fieldListTql = tqlQueryFromInput({
			input: [
				{
					fieldName: 'entityType',
					comparator: ComparatorOperator.EQUALS,
					fieldValue: 'GOAL',
				},
			],
		});
		const variables: VariablesOf<GoalSettingsViewQueryType> = {
			id: context.workspace?.globalId ?? '',
			workspaceUuid: context.workspace?.UUID ?? '',
			tql: fieldListTql,
			containerId: context.collabContext?.contextId ?? '',
		};

		return {
			query: GoalSettingsViewQuery,
			variables,
		};
	},
});
